import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility pro conditional + deduplikované Tailwind třídy.
 * Skládá clsx (conditional logika) a tailwind-merge (resolve konfliktů).
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
